import React, { Component } from 'react';
import { TableCell } from '@mui/material';

class GridSelectObjectCell extends Component {
    render() {
        const show = this.props.field.show;
        const value = this.props.value ? this.props.value : {};
        const currentValueName = value
            ? value.name
                ? value.name
                : value[show]
            : '';
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.label} align="left" sx={{ ...baseStyle }}>
                {currentValueName}
            </TableCell>
        );
    }
}

export default GridSelectObjectCell;
